import Table from '@hellodarwin/core/lib/components/common/table';
import styled from 'styled-components';
import { getProjectSingleSectionStyling } from '../styles';

export const ProjectSingleSectionContainer = styled.div`
  ${({ theme }) => getProjectSingleSectionStyling(theme)}
  gap: 24px;
`;

export const ProjectSingleSectionHeaderContainer = styled.div``;

export const PurpleHeaderTable = styled(Table)`
  .ant-table {
    border: 1px solid ${({ theme }) => theme.colors.grey_1};
    border-bottom: none;
  }
  .ant-table-thead > tr > th {
    background: ${({ theme }) => theme.colors.purple_2} !important;
    color: ${({ theme }) => theme.colors.white_1} !important;
    border-right: 1px solid ${({ theme }) => theme.colors.purple_1};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_1} !important;
    &:last-child {
      border-right: none;
    }
    &:before {
      display: none !important;
    }
  }
  .ant-table-tbody > tr > td {
    border-right: 1px solid ${({ theme }) => theme.colors.grey_1};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_1};
    &:last-child {
      border-right: none;
    }
  }
` as typeof Table;
